var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe347(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.523,
    height: 20,
    viewBox: "0 0 15.523 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.933,25.171a2.609,2.609,0,0,0,3.316,1.08,2.609,2.609,0,0,0,5.189,0,2.61,2.61,0,0,0,2.594-4.494,2.609,2.609,0,0,0-2.594-4.493,2.609,2.609,0,0,0-5.189,0,2.609,2.609,0,0,0-2.594,4.493A2.612,2.612,0,0,0,9.933,25.171Zm4.7-5.507a2.418,2.418,0,1,1-.886,3.3A2.419,2.419,0,0,1,14.635,19.663Z",
    transform: "translate(-8.083 -14.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.072,30.555c0-1.508-1.906-5.862-7.761-5.605.8,8.025,6.135,8.189,7.761,8.189s6.965-.164,7.762-8.189C17.978,24.693,16.072,29.047,16.072,30.555Z",
    transform: "translate(-8.311 -13.139)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe347);
export default __webpack_public_path__ + "static/media/Groupe_347.96c179c7008c45cdabf29dd909976d3d.svg";
export { ForwardRef as ReactComponent };